'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { useSidebarPrefsStore } from '@/shared/stores/sidebar-prefs-store';

/**
 * Urmărește pathname-ul curent și îl adaugă în lista „Recente" din sidebar.
 * Se montează o singură dată în dashboard layout — nu randează nimic.
 */
export function RecentPagesTracker() {
  const pathname = usePathname();
  const trackVisit = useSidebarPrefsStore((s) => s.trackVisit);

  useEffect(() => {
    if (pathname) trackVisit(pathname);
  }, [pathname, trackVisit]);

  return null;
}
